export var ReviewSummaryDataHooks;
(function (ReviewSummaryDataHooks) {
    ReviewSummaryDataHooks["Item"] = "item";
})(ReviewSummaryDataHooks || (ReviewSummaryDataHooks = {}));
//# sourceMappingURL=types.js.map